module.exports = __webpack_public_path__ + "static/media/aspirinProtect.a73188e8.mp3";